import { styled, Typography } from '@mui/material'

export const TextBlock = styled(Typography)`
  p {
    margin: 0;
  }

  b {
    margin: 0;
  }

  a {
    margin: 0;
  }

  li.editor-nested-listitem {
    list-style-type: none;
  }

  table {
    width: 100%;
  }

  th,
  td {
    padding: ${({ theme }) => theme.spacing(1)};
  }

  th {
    background-color: ${({ theme }) => theme.palette.secondary.light} !important;
  }

  th > * {
    font-weight: bold;
  }
`
